<template>
  <v-btn small text block color="grey lighten-1" :outlined="outlined"
    ><v-icon small>mdi-plus</v-icon></v-btn
  >
</template>

<script>
export default {
  name: 'AdminCellEmptyPlaceholder',
  props: {
    outlined: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
}
</script>
